import axios from './axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

export default function useSearchUser() {
  const common = (cohort, query) => ({ params: { cohort, q: query } });
  const [state, q] = useAxios({
    url: '/api/v1/lwadmin/users/_search',
    method: 'GET',
  }, { manual: true });
  const executeQuery = (cohort, query) => q(common(cohort, query));
  return [state, executeQuery];
}
